import { Icon } from '@chakra-ui/react';
import React, { SVGAttributes } from 'react';

function SummaryIconFirst(props: SVGAttributes<SVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="28.14" height="28.14" fill="none" viewBox="0 0 29 29" {...props}>
      <mask id="path-1-inside-1_228:1237" fill="#fff">
        <path d="M22.6 8.178l-6.156-6.156a.798.798 0 00-.616-.263H7.035c-.967 0-1.759.791-1.759 1.758v21.105c0 .967.792 1.759 1.759 1.759h14.07c.967 0 1.758-.792 1.758-1.76V8.794a.798.798 0 00-.264-.615zm-6.772-4.309l4.925 4.924h-4.925V3.87zm5.277 20.753H7.035V3.517h7.035v5.276c0 .968.791 1.76 1.758 1.76h5.277v14.069z"></path>
      </mask>
      <path
        fill="#374151"
        d="M22.6 8.178l-6.156-6.156a.798.798 0 00-.616-.263H7.035c-.967 0-1.759.791-1.759 1.758v21.105c0 .967.792 1.759 1.759 1.759h14.07c.967 0 1.758-.792 1.758-1.76V8.794a.798.798 0 00-.264-.615zm-6.772-4.309l4.925 4.924h-4.925V3.87zm5.277 20.753H7.035V3.517h7.035v5.276c0 .968.791 1.76 1.758 1.76h5.277v14.069z"
      ></path>
      <path
        fill="#374151"
        d="M22.6 8.178L11.992 18.785 22.599 8.178zm-6.156-6.156L27.051-8.584 16.444 2.022zm-.616 1.847L26.435-6.738.828-32.344V3.869h15zm4.925 4.924v15h36.213L31.36-1.813 20.754 8.793zm-4.925 0h-15v15h15v-15zm5.277 15.829v15h15v-15h-15zm-14.07 0h-15v15h15v-15zm0-21.105v-15h-15v15h15zm7.035 0h15v-15h-15v15zm7.035 7.035h15v-15h-15v15zm12.101-12.98l-6.155-6.156L5.837 12.629l6.156 6.156L33.206-2.43zm-6.155-6.156a15.904 15.904 0 00-4.79-3.299 15.816 15.816 0 00-6.433-1.359v30c-1.618 0-3.637-.287-5.75-1.226a14.1 14.1 0 01-4.24-2.903L27.05-8.584zm-11.223-4.658H7.035v30h8.793v-30zm-8.793 0c-9.252 0-16.759 7.508-16.759 16.76h30c0 7.316-5.924 13.24-13.241 13.24v-30zM-9.724 3.519v21.104h30V3.517h-30zm0 21.104c0 9.252 7.507 16.759 16.759 16.759v-30c7.317 0 13.241 5.924 13.241 13.24h-30zM7.035 41.38h14.07v-30H7.035v30zm14.07 0c9.251 0 16.758-7.508 16.758-16.76h-30c0-7.316 5.925-13.24 13.242-13.24v30zm16.758-16.76V8.794h-30v15.829h30zm0-15.828c0-1.882-.331-4.12-1.358-6.432a15.904 15.904 0 00-3.299-4.79L11.993 18.784a14.097 14.097 0 01-2.903-4.24 14.186 14.186 0 01-1.227-5.75h30zM5.222 14.476l4.924 4.924L31.36-1.813l-4.924-4.925L5.222 14.476zm15.53-20.683h-4.924v30h4.925v-30zm10.076 15V3.87h-30v4.924h30zm-9.723.829H7.035v30h14.07v-30zm.93 15V3.517h-30v21.105h30zm-15-6.105h7.035v-30H7.035v30zm-7.965-15v5.276h30V3.517h-30zm0 5.276c0 9.252 7.507 16.76 16.758 16.76v-30c7.317 0 13.242 5.923 13.242 13.24h-30zm16.758 16.76h5.277v-30h-5.277v30zm-9.723-15v14.069h30v-14.07h-30z"
        mask="url(#path-1-inside-1_228:1237)"
      ></path>
      <path fill="#374151" d="M8.794 19.346h10.552v1.759H8.794v-1.76zM8.794 14.07h10.552v1.758H8.794V14.07z"></path>
    </svg>
  );
}

function SummaryIconSecond(props: SVGAttributes<SVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
      <path
        fill="#374151"
        d="M6.808 0a.84.84 0 01.84.84v1.57h9.02V.85a.84.84 0 011.68 0v1.56H21.6a2.4 2.4 0 012.4 2.4V21.6A2.4 2.4 0 0121.6 24H2.4A2.4 2.4 0 010 21.601V4.81a2.4 2.4 0 012.4-2.4h3.568V.84A.84.84 0 016.808 0zM1.68 9.29v12.311a.72.72 0 00.72.72h19.2a.72.72 0 00.72-.72V9.307L1.68 9.29zM8 17.543v1.999H6v-2h2zm5 0v1.999h-2v-2h2zm5 0v1.999h-2v-2h2zM8 12.77v2H6v-2h2zm5 0v2h-2v-2h2zm5 0v2h-2v-2h2zM5.968 4.09H2.4a.72.72 0 00-.72.72v2.802l20.64.016V4.81a.72.72 0 00-.72-.72h-3.252v1.114a.84.84 0 01-1.68 0V4.09h-9.02v1.104a.84.84 0 01-1.68 0V4.09z"
      ></path>
    </svg>
  );
}

function SummaryIconThird(props: SVGAttributes<SVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24.97" fill="none" viewBox="0 0 25 25" {...props}>
      <path
        fill="#374151"
        stroke="#374151"
        strokeWidth="1.5"
        d="M1.333 22.917v.75h22.334V1.333H1.333v21.584zM2.083.75h20.834a1.333 1.333 0 011.333 1.333v20.834a1.334 1.334 0 01-1.333 1.333H2.083A1.334 1.334 0 01.75 22.917V2.083A1.333 1.333 0 012.083.75z"
      ></path>
      <path
        fill="#374151"
        stroke="#374151"
        strokeWidth="1.5"
        d="M9.891 15.483l.528.519.526-.522 7.19-7.132.592.589-8.31 8.236-4.137-4.104.58-.563 3.031 2.977z"
      ></path>
    </svg>
  );
}

function SummaryIconForth(props: SVGAttributes<SVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="26" height="28" fill="none" viewBox="0 0 26 20" {...props}>
      <path
        fill="#374151"
        d="M7.15 13.575c-.975.163-2.275-.487-2.762-.65l-.813 1.462s1.463.65 2.763.813v1.3h1.625v-1.463c1.462-.487 2.275-1.787 2.437-2.925 0-1.3-.975-2.274-3.087-3.087-.65-.325-1.788-.813-1.788-1.463 0-.812.65-1.3 1.625-1.3 1.138 0 2.275.488 2.275.488l.65-1.463s-.812-.324-1.95-.65V3.5H6.5v1.138c-1.462.325-2.437 1.3-2.6 2.762 0 1.95 2.113 2.762 2.925 3.088.975.325 2.113.975 2.113 1.462 0 .65-.65 1.463-1.788 1.625z"
      ></path>
      <path fill="#374151" d="M0 .25v19.5h26V.25H0zm24.375 17.875H1.625V1.875h22.75v16.25z"></path>
      <path fill="#374151" d="M13 5.125h9.75V6.75H13V5.125zM13 8.375h9.75V10H13V8.375zM13 11.625h4.875v1.625H13v-1.625z"></path>
    </svg>
  );
}

function SummaryIconFifth(props: SVGAttributes<SVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="27" height="26.97" fill="none" viewBox="0 0 27 27" {...props}>
      <path
        fill="#374151"
        d="M13.5 0C6.048 0 0 6.048 0 13.5S6.048 27 13.5 27 27 20.952 27 13.5 20.952 0 13.5 0zm0 24.3c-5.954 0-10.8-4.847-10.8-10.8 0-5.954 4.846-10.8 10.8-10.8 5.953 0 10.8 4.846 10.8 10.8 0 5.953-4.847 10.8-10.8 10.8zm1.201-12.015c-2.402-.796-3.564-1.296-3.564-2.565 0-1.377 1.499-1.877 2.444-1.877 1.769 0 2.417 1.337 2.565 1.81l2.133-.905c-.203-.594-1.107-2.578-3.591-3.01V4.05h-2.363v1.701c-3.51.756-3.536 3.847-3.536 3.996 0 3.065 3.037 3.928 4.522 4.469 2.133.756 3.078 1.444 3.078 2.74 0 1.526-1.417 2.174-2.673 2.174-2.457 0-3.159-2.525-3.24-2.822l-2.241.904c.85 2.957 3.078 3.753 4.077 3.997v1.741h2.363v-1.674c.701-.122 4.076-.796 4.076-4.347.014-1.876-.81-3.523-4.05-4.644z"
      ></path>
    </svg>
  );
}

function CircleIcon(props: any) {
  return (
    <Icon viewBox="0 0 200 200" {...props}>
      <path fill="currentColor" d="M 100, 100 m -75, 0 a 75,75 0 1,0 150,0 a 75,75 0 1,0 -150,0" />
    </Icon>
  );
}

export default SummaryIconFirst;
export { SummaryIconSecond, SummaryIconThird, SummaryIconForth, SummaryIconFifth, CircleIcon };
